import React from 'react'
import { Snackbar, SnackbarContent, Button } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import style from 'style/SnackBar.css'

class SnackBar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      snackMessage: ' ',
      type:'error'
    }
  }

  openSnackbar = (message, type='error') => {
    this.setState({ snackMessage: message, open: true, type });
  }
  handleClose = () => {
    this.setState({ open: false });
  };
  closeAction = (
    <Button style={{ color: "#fff", 'min-width': 'auto', padding: 0 }} onClick={this.handleClose} >
      <CloseRoundedIcon></CloseRoundedIcon>
    </Button>
  );
  render(){
    return (<Snackbar
      classes={{ root: `ti-snackbar-root ${this.state.type}`,  }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={this.state.open}
      onClose={this.handleClose}
    >
      <SnackbarContent
        message={this.state.snackMessage}
        classes={{ root: 'ti-snackbarcontent-root-default' }}
        action={this.closeAction}
      >

      </SnackbarContent>
    </Snackbar>)
  }
}

export default SnackBar